<template>
    <div class="col-12">
        <div class="annotations-side-card geometry-card" :class="{'disabled': disabled}"
            @click.prevent="onSelect"
            @mouseenter="onGeometryHighlight(fid)"
            @mouseleave="onGeometryHighlight(fid, false)">

            <div class="annotations-side-card__wrapper">
                <div class="annotations-side-card__wrapper__container">
                    <div class="side-card-content">
                        <div class="side-card-content__left-container justify-content-center">
                            <div class="d-flex flex-nowrap">
                                <div class="side-card-icon">
                                    <img :src="icon" alt="Geometry" />
                                </div>
                                <div class="side-card-info">
                                    <div class="side-card-info__title">
                                        <span>{{ title }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="side-card-content__right-container">
                         <div class="side-card-tool text-center">
                            <div class="btn-group my-0">
                                <button
                                    v-if="zoomToFeature"
                                    type="button"
                                    class="btn btn-sm min-w-auto btn-add"
                                    data-toggle="tooltip-city"
                                    title="Zoom para geometria"
                                    :disabled="disabled || !isValidFeature"
                                    @click.stop="onZoomTo">
                                    <i class="fas fa-search-location"></i>
                                </button>
                                <button
                                    v-if="removeFeature"
                                    type="button"
                                    class="btn btn-sm min-w-auto btn-add"
                                    data-toggle="tooltip-city"
                                    title="Remover"
                                    :disabled="disabled"
                                    @click.stop="onRemove">
                                    <i class="fas fa-trash-alt"></i>
                                </button>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import GlobalMixin from '@/app/shared/mixins/global';
    import {IS_CIRCLE_PROPERTY, ACTION_CIRCLE} from './../AnnotationConstants';

    export default {
        name: 'AnnotationRecordItemFeature',
        mixins: [
            GlobalMixin,
        ],
        components: {
        },
        props: {
            feature: {
                type: Object,
                required: true,
                default: () => {},
            },
            controlsConfig: {
                type: Object,
                required: true,
                default: () => {},
            },
            zoomToFeature: {
                type: Boolean,
                default: true,
            },
            removeFeature: {
                type: Boolean,
                default: true,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                selectedGeometry: null,
            }
        },
        mounted() {

        },
        computed: {
            geometry() {
                return this.feature ? this.feature.geometry : {};
            },
            properties() {
                return this.feature ? this.feature.properties : {};
            },
            fid() {
                return this.properties.id || null;
            },
            geometryType() {
                return this.geometry ? this.geometry.type : null;
            },
            icon() {
                let config = this.controlsConfig;
                let type = this.geometryType ? this.geometryType.toLowerCase() : null;
                if(type){
                    type = type == 'point' && this.properties[IS_CIRCLE_PROPERTY] ? ACTION_CIRCLE.type.toLowerCase() : type;
                    let key = Object.keys(config).find(key => config[key].type.toLowerCase() == type);
                    if(key) {
                        return config[key].img || config[key].icon;
                    }
                }
                return null;
            },
            title() {
                return this.properties.geometryTitle || this.geometryType;
            },
            isValidFeature() {
                return !!this.properties.isValidFeature || true;
            },
            isVisible() {
                return this.isValidFeature;
            },

        },
        methods: {
            onSelect() {
                if(!this.disabled) {
                    this.hideTooltip();
                    this.$emit('selectedFeature', this.fid);
                }
            },
            onZoomTo() {
                if(!this.disabled) {
                    this.hideTooltip();
                    this.$emit('zoomToFeature', this.fid);
                }
            },
            onRemove() {
                if(!this.disabled) {
                    this.hideTooltip();
                    this.$emit('removeFeature', this.fid);
                }
            },
            onGeometryHighlight(id, highlight = true) {
                this.$emit('geometryHighlight', {id, highlight});
            },
        },
        watch: {
        },
    }
</script>

<style scoped lang="scss">
    .side-card-icon {
        margin-right: 10px;
        img {
            width: 24px;
        }
    }
</style>